import React from 'react';
import { Message, Table } from 'semantic-ui-react';
import { Resultados } from 'src/api';
import { mesesPlanAnual, mesesPlanIntensivo } from 'src/recursos/mesesEnsayo';

type PuntajesDTO = Resultados<'obtenerPuntajeEnsayos'>;

const nombresDePruebas = {
    lenguaje: 'Lenguaje',
    matematica: 'Matemática',
    historia: 'Historia',
    biologia: 'Biología',
    fisica: 'Física',
    quimica: 'Química',
    tecnico: 'Técnico',
};

export type Props = Readonly<{
    puntajes?: PuntajesDTO;
    plan: 'anual' | 'intensivo';
}>;

class Puntajes extends React.PureComponent<Props> {
    public render() {
        const { puntajes, plan } = this.props;

        if (!puntajes) {
            return (
                <Message info>
                    El alumno no posee puntajes registrados o está restringido para verlos.
                </Message>
            );
        }

        const meses = plan === 'anual' ? mesesPlanAnual : mesesPlanIntensivo;

        const pruebas = keys(puntajes)
            .sort()
            .map(p => tuple(nombresDePruebas[p], puntajes[p]));
        const nombresMeses = keys(meses);

        return (
            <Table collapsing celled definition textAlign='center'>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell />
                        {nombresMeses.map(mes => (
                            <Table.HeaderCell key={mes}>{meses[mes]}</Table.HeaderCell>
                        ))}
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {pruebas.map(([nombre, resultadosPorMes], indexPruebas) => (
                        <Table.Row key={indexPruebas}>
                            <Table.Cell textAlign='left'>{nombre}</Table.Cell>
                            {nombresMeses.map((mes, indexMes) =>
                                resultadosPorMes && mes in resultadosPorMes ? (
                                    <Table.Cell key={indexMes}>
                                        {resultadosPorMes[mes]!.puntaje}
                                    </Table.Cell>
                                ) : (
                                    <Table.Cell key={indexMes} />
                                ),
                            )}
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        );
    }
}

function keys<T extends object>(obj: T) {
    return Object.keys(obj) as Array<keyof T>;
}

// tslint:disable-next-line: no-any
function tuple<T extends any[]>(...elements: T): T {
    return elements;
}

export default Puntajes;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/Puntajes/index.tsx